<div *ngIf="!openConfirmation" class="stepper-panel">
  <div class="container m--full-bleed">
    <div class="row m--full-bleed">
      <div class="col-12">
        <div class="form-panel">
          <mat-stepper [orientation]="stepperOrientation" #stepper linear="true">
            <!-- 1. T&C -->
            <mat-step class="stepper-icon" [stepControl]="termsFrmGp">
              <form [formGroup]="termsFrmGp">
                <ng-template matStepLabel>Terms and Conditiondfsdfsdfs</ng-template>
                <div>
                  <div #cguContainer class="terms-panel" (scroll)="checkReading()" [innerHTML]="termsContent"></div>
                </div>
                <div class="mt-3">
                  <label class="smart-checkbox pb-2">
                    <input type="checkbox" aria-label="checkbox" class="form-check-input smart-checks checkmark" formControlName="accepted"
                      required>
                    <span>Accept Terms and Conditions</span>
                    <span class="checkmark"></span>
                    <p class="c-red1 ts-s" *ngIf="isTermsSubmitted && termsFrmGp.get('accepted')?.value !== true">
                      Please accept the terms and conditions to move forward.</p>
                  </label>
                </div>
                <div class="flex-btn-row pt-2 pb-2">
                  <button class="btn btn-secondary" mat-button matStepperPrevious
                    (click)="goToACHDLanding()">Back</button>
                  <button class="btn btn-primary-short" (click)="submitTerms()" mat-button matStepperNext>Next</button>
                </div>
              </form>
            </mat-step>
            <!-- 2. Select Payment Account -->
            <mat-step class="stepper-icon" [stepControl]="bankFrmGp">
              <form [formGroup]="bankFrmGp">
                <ng-template matStepLabel>Select Payment Account</ng-template>
                <div class="">
                  <div *ngIf="paymentaccounts && paymentaccounts?.length; else noaccount">
                    <div class="mat-card-header-row">
                      <h4 class="mb-0">Select Account</h4>
                      <a class="ico-btn" [routerLink]="['/employer/achd/paymentaccounts']">
                        Add
                        <span class="fa fa-plus-circle fa-md-blue dib ml-1" matTooltipClass="tooltip-md"
                          matTooltip="ADD NEW BANK ACCOUNT">
                        </span>
                      </a>
                    </div>
                    <div class="search-result-panel">
                      <table class="table">
                        <thead>
                          <tr>
                            <th *ngFor="let col of paymentaccountheader">{{col}}</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngIf="isLoadingAccounts">
                            <span><i class="fa fa-refresh fa-spin fa-2x fa-fw mt-4"></i></span>
                          </tr>
                          <tr *ngFor="let account of paymentaccounts; let i = index"
                            [ngClass]="{'paymentAccountActive' : account.isSelected}">
                            <td>
                              <label *ngIf="!account.holdStatus" class="smart-checkbox">
                                <input type="checkbox" aria-label="bankAcct" (change)="addRemoveAccount($event, i, account)"
                                  formControlName="bankAcct" [checked]="account.isSelected">
                                <span class="checkmark"></span> 
                              </label>
                            </td>

                            <td>{{account.bankName}}</td>
                            <td>{{account.accountTypeName}}</td>
                            <td>{{account.accountNumberMasked}}</td>
                            <td
                              [ngClass]="{'paymentAccountHold' : account.holdStatus || account.prenoteStatus === prenoteEnum.Failed}"
                              matTooltip="{{account.holdStatus ? 'This account is currently on hold and not eligible for ACH debit.' :
                                                            account.prenoteStatus === prenoteEnum.Prenote ? 'A prenote (or prenotification) is a zero dollar test to validate the
                                                                                            employee bank account information. Prenotes are sent and verified before
                                                                                            direct deposit payroll can be processed.' :
                                                            account.prenoteStatus === prenoteEnum.Failed ? 'Bank Account has FAILED to become active.  Please contact us for more information':
                                                                                    'Bank Account is Active'}}"
                              matTooltipClass="tooltip-md">
                              {{account.holdStatus ? 'On Hold' :
                              account.prenoteStatus === prenoteEnum.Prenote ? 'Prenote' :
                              account.prenoteStatus === prenoteEnum.Failed ? 'Failed' : 'Active' }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <ng-template #noaccount class="mt-3">
                    <h4>No Bank Account Found</h4>
                    <div class="flex-input-col pt-2 pb-2">
                      <p>
                        You must create a bank account before scheduling a payment. Click the "Add" button
                        to create a bank account.
                      </p>
                      <div>Add
                        <a (click)="goToPaymentAccount()">
                          <span class="fa fa-plus-circle fa-md-blue" matTooltipClass="tooltip-md"
                            matTooltip="ADD NEW BANK ACCOUNT">
                          </span>
                        </a>
                      </div>
                    </div>
                  </ng-template>
                </div>
                <div class="flex-btn-row pt-2 pb-2">
                  <button class="btn btn-secondary" mat-button matStepperPrevious>Back</button>
                  <button class="btn btn-primary-short" [disabled]="!isBankAccountSelected" mat-button
                    matStepperNext>Next</button>
                </div>
              </form>
            </mat-step>
            <!-- 3. Payor Info -->
            <mat-step>
              <ng-template matStepLabel>Complete Payor Information</ng-template>

            </mat-step>
            <!-- 4. Payment Detail Info -->
            <mat-step [stepControl]="paymentDetailFrmGp">
              <form [formGroup]="paymentDetailFrmGp">
                <ng-template matStepLabel>Complete Payment Detail Information</ng-template>
                <div class="flex-input-col pt-2 pb-2">
                  <mat-form-field>
                    <input matInput placeholder="Scheduled Payment Nickname" formControlName="nickname"
                      autocomplete="off">
                    <mat-hint>Name your scheduled payment to help identify it, such as "Hourly Employees" or "Salary
                      Employees".</mat-hint>
                    <mat-error *ngIf="paymentDetailFrmGp.get('nickname')!.hasError('maxlength')">Nickname must be 40
                      characters or less</mat-error>

                  </mat-form-field>
                </div>
                <div class="flex-input-col pt-2 pb-2">
                  <mat-form-field>
                    <mat-select matInput disableOptionCentering panelClass="matSelectClass"
                      placeholder="Select frequency" formControlName="frequency">
                      <mat-option *ngFor="let freq of scheduledFrequencies" [value]="freq.scheduleFrequency">
                        {{freq.scheduleFrequencyName}}
                      </mat-option>
                    </mat-select>
                    <mat-error>Required</mat-error>
                  </mat-form-field>
                  <div *ngIf="showScheduleDay">
                    <mat-form-field>
                      <mat-select matInput disableOptionCentering panelClass="matSelectClass" placeholder="Select day"
                        formControlName="scheduledday">
                        <mat-option *ngFor="let day of scheduledDays" [value]="day.scheduleDay">
                          {{day.scheduleDayName}}
                        </mat-option>
                      </mat-select>
                      <mat-error>Required</mat-error>
                    </mat-form-field>
                  </div>
                </div>
                <div class="flex-input-col pt-2 pb-2 input-group mb-3">
                  <mat-form-field appearance="standard" class="calendarInput">
                    <input matInput readonly angular-mydatepicker name="startday" formControlName="startday"
                      [options]="dateSettingsOptions" #dp="angular-mydatepicker" placeholder="Choose a Start Date"
                      (dateChanged)="dateFormat($event)">
                    <mat-icon matSuffix class="input-group-addon calendarBox" (click)="dp.toggleCalendar()">
                      <i class="fa fa-calendar-o fa-md-gray-calendar"></i>
                    </mat-icon>
                    <mat-hint>{{calendarHint}}</mat-hint>
                    <mat-error>Required</mat-error>
                  </mat-form-field>
                </div>
                <div class="flex-btn-row pt-2 pb-2">
                  <button class="btn btn-secondary" mat-button matStepperPrevious>Back</button>
                  <button *ngIf="!paymentDetailFrmGp.errors" class="btn btn-primary-short" mat-button
                    matStepperNext>Next</button>
                </div>
              </form>
            </mat-step>
            <!-- 5. Review -->
            <mat-step *ngIf="!isLoadingNextScheduledDate; else loading" [stepControl]="reviewFrmGrp">
              <form [formGroup]="reviewFrmGrp">
                <ng-template matStepLabel>Review Your Information</ng-template>
                <div class="container">
                  <div *ngIf="nextScheduledDate" class="mb-5">
                    <!-- Scheduled payment information card-->
                    <mat-card class='mat-card-display' tabindex="0">
                      <mat-card-header>
                        <mat-card-title class="justify-content-start">
                          <h2 class="mat-card-title align-items-start">
                            <span class="fa fa-credit-card fa-md-black mr-2"></span> Scheduled Payment Information
                          </h2>
                        </mat-card-title>
                      </mat-card-header>
                      <mat-card-content>
                        <div class="row review-payment">
                          <div class="col-12 col-lg-4">
                            <dl class="account-details-sum">
                              <div class="account-sum-row">
                                <dt class="account-dt">
                                  Bank Name
                                </dt>
                                <dd class="account-dt-info">{{selectedPaymentAccount?.bankName}}</dd>
                              </div>
                              <div class="account-sum-row">
                                <dt class="account-dt">
                                  Account Type
                                </dt>
                                <dd class="account-dt-info">{{selectedPaymentAccount?.accountType}}</dd>
                              </div>
                              <div class="account-sum-row">
                                <dt class="account-dt">
                                  Account
                                </dt>
                                <dd class="account-dt-info">{{selectedPaymentAccount?.accountNumberMasked}}</dd>
                              </div>
                            </dl>
                          </div>
                          <div class="col-12 col-lg-4">
                            <dl class="account-details-sum">
                              <div class="account-sum-row">
                                <dt class="account-dt">
                                  Number of Payor(s)
                                </dt>
                                <dd class="account-dt-info">{{numOfPayments}}</dd>
                              </div>
                              <div class="account-sum-row">
                                <dt class="account-dt">
                                  Total Amount
                                </dt>
                                <dd class="account-dt-info">{{totalAmtOfPayments | currency}}</dd>
                              </div>
                            </dl>
                          </div>
                          <div class="col-12 col-lg-4">
                            <dl class="account-details-sum">
                              <div class="account-sum-row">
                                <dt class="account-dt">
                                  Nickname
                                </dt>
                                <dd class="account-dt-info">{{paymentDetailFrmGp.get('nickname')?.value}}</dd>
                              </div>
                              <div class="account-sum-row">
                                <dt class="account-dt">
                                  Frequency
                                </dt>
                                <dd class="account-dt-info">{{selectedFrequency}}</dd>
                              </div>
                              <div class="account-sum-row">
                                <dt class="account-dt">
                                  Day
                                </dt>
                                <dd class="account-dt-info">{{selectedDay}}</dd>
                              </div>
                            </dl>
                          </div>
                          <div class="col-12 mb-5">
                            <dl class="account-details-sum">
                              <div class="account-sum-row">
                                <dt class="account-dt">
                                  Effective Date
                                </dt>
                                <dd class="account-dt-info">{{startDate | validDate}}</dd>
                              </div>
                              <div class="account-sum-row">
                                <dt class="account-dt">
                                  Next Scheduled Payment Date
                                </dt>
                                <dd class="account-dt-info">{{nextScheduledDate| date:'MM/dd/yyyy'}}</dd>
                              </div>
                            </dl>
                          </div>
                          <div class="col-12">
                            <p>
                              Payments will post to your employees&rsquo; child support case on the
                              day money is drafted from your bank account. If the draft falls
                              on a weekend or holiday the payment will be drafted and posted
                              the next business day.
                            </p>
                          </div>
                        </div>
                      </mat-card-content>
                    </mat-card>
                  </div>
                  <div class="t-alignC" *ngIf="insertUpdateError">
                    <p class="c-red1"><strong>ERROR: {{insertUpdateErrorMessage}}</strong></p>
                  </div>
                  <div class="flex-btn-row pt-2 pb-2">
                    <button class="btn btn-secondary" mat-button matStepperPrevious>Back</button>
                    <button class="btn btn-submit" mat-raised-button [disabled]="disableCreatePaymentButton"
                      (click)="insertUpdatePayment()">{{createPaymentButtonText}}
                    </button>

                  </div>
                </div>
              </form>
            </mat-step>
            <ng-template #loading>
              Loading....
            </ng-template>
          </mat-stepper>
        </div>
      </div>
    </div>
  </div>
</div>

<epay-lib-common-confirmation *ngIf="openConfirmation" [sender]="confirmationSender"
  [confirmationTitle]="confirmationTitle" [confirmationMessage]="confirmationMessage"
  [confirmationNumber]="confirmationNumber" [goToPrimary]="goToPrimary" [goToPrimaryUrl]="goToPrimaryUrl"
  (confirmationEmitter)="hideConfirmationPage()">
</epay-lib-common-confirmation>